import React from "react";
import { Check, X } from "lucide-react";
import { usePrice } from "@/lib/price";

const youAre = [
  "An operator who'd rather ship than scroll Twitter for hacks",
  "A job seeker tired of ATS black holes and ghost listings",
  "A founder building side income while keeping the day job sane",
  "A creator who wants the content engine on top of the career engine",
  "Someone who hates subscriptions but pays once for tools that work",
];

const buildNotYou = (price) => [
  "You want a 12-week cohort and a Slack of strangers",
  "You're shopping for another Notion template dump",
  "You want a magic button that auto-applies to 500 jobs",
  `You think ${price} is too risky to find out if a thing works`,
  "You'd rather watch tutorials than build the thing tonight",
];

export default function WhoFor() {
  const { price } = usePrice();
  const notYou = buildNotYou(price);
  return (
    <section
      id="who"
      data-testid="who-for"
      className="border-b-4 border-[#0a0a0a] bg-[#FDFBF7]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="text-center mb-12 md:mb-14 reveal">
          <div className="font-accent text-sm bg-[#FF3B30] text-white inline-block px-3 py-1 mb-4">
            FIT CHECK
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl">
            Built for{" "}
            <span className="bg-[#FFE600] px-2">one kind</span>
            <br />
            of person.
          </h2>
          <p className="font-mono-body mt-5 max-w-xl mx-auto text-[#0a0a0a]/75 text-base">
            We don&apos;t try to be for everyone. Read both lists. If the left
            sounds like you, the rest of this page is for you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <div
            data-testid="whofor-you"
            className="reveal bg-[#00FF66] border-4 border-[#0a0a0a] shadow-brutal hover-pop p-7 md:p-9"
          >
            <div className="font-accent text-xs bg-[#0a0a0a] text-[#FFE600] inline-block px-2.5 py-1 mb-5">
              THIS IS YOU ✓
            </div>
            <ul className="space-y-4">
              {youAre.map((y) => (
                <li
                  key={y}
                  className="flex items-start gap-3 font-mono-body text-[15px] leading-snug"
                >
                  <span className="shrink-0 w-7 h-7 bg-[#0a0a0a] text-[#FFE600] border-2 border-[#0a0a0a] flex items-center justify-center">
                    <Check size={14} strokeWidth={3} />
                  </span>
                  {y}
                </li>
              ))}
            </ul>
          </div>

          <div
            data-testid="whofor-not-you"
            className="reveal bg-white border-4 border-[#0a0a0a] shadow-brutal hover-pop p-7 md:p-9"
          >
            <div className="font-accent text-xs bg-[#FF3B30] text-white inline-block px-2.5 py-1 mb-5">
              NOT FOR YOU ✗
            </div>
            <ul className="space-y-4">
              {notYou.map((y) => (
                <li
                  key={y}
                  className="flex items-start gap-3 font-mono-body text-[15px] leading-snug text-[#0a0a0a]/55"
                >
                  <span className="shrink-0 w-7 h-7 bg-white text-[#FF3B30] border-2 border-[#0a0a0a] flex items-center justify-center">
                    <X size={14} strokeWidth={3} />
                  </span>
                  {y}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
